import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';
import firebaseAppletConfig from '../firebase-applet-config.json';

// Your web app's Firebase configuration using environment variables combined with fallback
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || firebaseAppletConfig.apiKey,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || firebaseAppletConfig.authDomain,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || firebaseAppletConfig.projectId,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || firebaseAppletConfig.storageBucket,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || firebaseAppletConfig.messagingSenderId,
  appId: import.meta.env.VITE_FIREBASE_APP_ID || firebaseAppletConfig.appId,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || firebaseAppletConfig.measurementId,
};

// Initialize Firebase
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

// Initialize Analytics (only in browser environments)
export const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;

// Initialize Auth and Firestore
export const auth = getAuth(app);

// Use named database if provided in env, otherwise fallback to configuration
const databaseId = import.meta.env.VITE_FIREBASE_DATABASE_ID || firebaseAppletConfig.firestoreDatabaseId || '(default)';

export const db = getFirestore(app, databaseId);

export const googleProvider = new GoogleAuthProvider();

// Initialize App Check
let appCheck: any = null;

export const initAppCheck = () => {
  if (appCheck) return appCheck;

  try {
    const siteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
    if (!siteKey) {
      console.warn('VITE_RECAPTCHA_SITE_KEY is missing. App Check cannot protect your database.');
      return null;
    }

    // Initialize App Check with ReCaptcha Enterprise
    appCheck = initializeAppCheck(app, {
      provider: new ReCaptchaEnterpriseProvider(siteKey),
      isTokenAutoRefreshEnabled: true,
    });
    
    console.log('Firebase App Check accurately initialized for maximum security.');
  } catch (error) {
    console.error('Failed to initialize Firebase App Check:', error);
  }

  return appCheck;
};
